import request from '@/utils/request'

// get all channels filter payin 1、payout 2
export function fetchInstituteListByType(params = {}) {
  return request({
    url: '/order/institute/typeList',
    method: 'get',
    params: params
  })
}

// get all channels
export function fetchInstituteList(params = {}) {
  return request({
    url: '/institutes',
    method: 'get',
    params: params
  })
}

// 获取代付银行列表
export function fetchDisbursementBankNameList(params = {}) {
  return request({
    url: '/merchant-api/bank/getBank',
    method: 'get',
    params: params
  })
}

// 获取所有渠道列表
export function fetchAllChannelList(data) {
  return request({
    url: '/channel/allChannelList',
    method: 'post',
    data
  })
}

// 获取电子钱包和银行
export function fetchDisbursementAllCodeList(params = {}) {
  return request({
    url: '/merchant-api/bank/codeList',
    method: 'get',
    params: params
  })
}

// get merchant available channel has type\

export function fetchAvailableChannelList(params = {}) {
  return request({
    url: '/payment/excel/channel/list',
    method: 'get',
    params: params
  })
}
// 获取 patmentMethod 对应的 channel code
export function fetchPageMethodChannelList(params = {}) {
  return request({
    url: '/merchant-api/channel/getChannelList',
    method: 'get',
    params
  })
}

// 获取商户目前上线国家
export function fetchOnlineCountryList(params) {
  return request({
    url: '/merchant-api/mch/getCountryList',
    method: 'get',
    params: params
  })
}

// 切换国家
export function changeCountry(data) {
  return request({
    url: '/merchant-api/mch/setCurrentCountry',
    method: 'post',
    data
  })
}

// 获取商户目前上线国家
export function getAllCountry(params) {
  return request({
    url: '/merchant-api/address/getAllCountry',
    method: 'get',
    params: params
  })
}

// 设置用户时区
export function setTimeZone(params) {
  return request({
    url: '/merchant-api/mch/user/timezone/setTimeZone',
    method: 'get',
    params: params
  })
}

// 获取所有国家
export function getKycAllCountry(params) {
  return request({
    url: '/merchant-api/kyc/address/getAllCountry',
    method: 'get',
    params: params
  })
}

// 获取多币种渠道列表
export function fetchMultiMchPageMethodChannelList(params = {}) {
  return request({
    url: '/merchant-api/channel/getMultiMchChannelList',
    method: 'get',
    params
  })
}
